import { configureStore } from '@reduxjs/toolkit';
import carnivalReducer from '../pages/carnival/carnivalSlice';

export const store = configureStore({
  reducer: {
    carnival: carnivalReducer
  }
});
